import React, { useState, useEffect } from 'react';
import { fetchArchivedServersAPI, updateServerAPI, hardDeleteServerAPI } from '../services/serverService';

const ArchivedServersPage = () => {
    const [servers, setServers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => { loadArchivedServers(); }, []);

    const loadArchivedServers = async () => {
        try {
            setIsLoading(true);
            const response = await fetchArchivedServersAPI();
            setServers(response.data.data.servers || []);
        } catch (error) {
            console.error("Failed to fetch archived servers", error);
            setServers([]); 
        } finally {
            setIsLoading(false);
        }
    };

    const handleUnarchive = async (server) => {
        if (window.confirm(`Are you sure you want to restore '${server.server_name}'? Users will regain access.`)) {
            try {
                await updateServerAPI(server.server_id, { status: 'active', reason: 'Restored from Archive' });
                alert('Server restored successfully.');
                loadArchivedServers();
            } catch (error) {
                alert("Failed to restore: " + (error.response?.data?.message || error.message));
            }
        }
    };

    const handleHardDelete = async (server) => {
        const confirmText = window.prompt(`DANGER: This will permanently delete '${server.server_name}' and ALL associated data (Users, Logs, Visits).\n\nType the Server ID (${server.server_id}) to confirm:`);
        
        if (confirmText === server.server_id) {
            try {
                setIsLoading(true);
                await hardDeleteServerAPI(server.server_id);
                alert('Server permanently deleted.');
                loadArchivedServers();
            } catch (error) {
                alert("Failed to delete: " + (error.response?.data?.message || error.message));
                setIsLoading(false);
            }
        } else if (confirmText !== null) {
            alert('Server ID did not match. Deletion cancelled.');
        }
    };

    return (
        <div className="page-container">
            <div className="page-header">
                <div>
                    <h1 style={{ color: '#718096' }}>Archived Servers</h1>
                    <p style={{ color: '#a0aec0', marginTop: '5px' }}>These servers and their users are currently disabled.</p>
                </div>
            </div>

            <div className="data-table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Server ID</th>
                            <th>Company Name</th>
                            <th>Phone</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="5" className="no-data-cell">Loading...</td></tr>
                        ) : servers.length > 0 ? servers.map((server) => (
                            <tr key={server.server_id} style={{ backgroundColor: '#f7fafc', color: '#718096' }}>
                                <td>{server.server_id}</td>
                                <td>{server.server_name}</td>
                                <td>{server.phone_number}</td>
                                <td>
                                    <span style={{ backgroundColor: '#cbd5e0', padding: '4px 8px', borderRadius: '4px', color: '#2d3748', fontSize: '0.8rem', fontWeight: 'bold' }}>
                                        Archived
                                    </span>
                                </td>
                                <td>
                                    <div className="actions-wrapper" style={{ display: 'flex', gap: '10px' }}>
                                        <button 
                                            className="action-button success" 
                                            onClick={() => handleUnarchive(server)}
                                        >
                                            Un-Archive (Restore)
                                        </button>
                                        <button 
                                            className="action-button danger" 
                                            onClick={() => handleHardDelete(server)}
                                        >
                                            Hard Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )) : (
                            <tr><td colSpan="5" className="no-data-cell">No Archived Servers Found</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ArchivedServersPage;